import { Button, ConfirmationModal, Icon, Modal } from '@fattureincloud/fic-design-system'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import parse from 'html-react-parser'
import React, { FC, forwardRef, PropsWithChildren } from 'react'
import ContentLoader, { BulletList } from 'react-content-loader'
import { Link } from 'react-scroll'
import styled, { css } from 'styled-components'

import FICColors from '../common/FICColors'

export const sidebarOffsetTop = !localStorage.getItem(
  'helpFacebookBannerIsVisible'
)
  ? 50
  : 40

export const helpHeaderHeight = !localStorage.getItem(
  'helpFacebookBannerIsVisible'
)
  ? 130
  : 90

export const LinkPoint = styled.span`
  height: 8px;
  width: 8px;
  background-color: #0294d3;
  display: block;
  border-radius: 100%;
  position: absolute;
  top: 10px;
  transition: height 100ms ease-out;
`

export const Confirm = styled(ConfirmationModal)`
   font-family: 'Open Sans', sans-serif !important;
`

export const HelpModal = styled(Modal)`
  font-family: 'Open Sans', sans-serif !important;
`

interface SectionLinkImplProps extends PropsWithChildren<FC> {
  className: string
  isActive: boolean
  to: string
  smooth: boolean
  offset: number
  containerId: string
}

export const SectionLinkImpl = forwardRef<HTMLDivElement, SectionLinkImplProps>(
  (forwardedProps,ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { ['isActive']: toDelete, ...rest } = forwardedProps
    return (
      <div className={forwardedProps.className} ref={ref}>
        <LinkPoint className='point' />
        <Link {...rest}
        />
      </div>
    )
  }
)

SectionLinkImpl.displayName = 'SectionLinkImpl'

export const SectionLink = styled(SectionLinkImpl)<{ isActive: boolean }>`
  font-size: 16px;
  line-height: 24px;
  display: block;
  cursor: pointer;
  position: relative;
  &:not(:last-child) {
    a {
      padding-bottom: 16px;
    }
  }
  &.active {
    a {
      color: #0294d3;
      font-weight: bold;
    }<
  }
  a {
    display: inline-block;
    color: #333;
    margin-left: 20px;
    vert-align: top;
    position: relative;
    max-width: 244px;
  }
  &:hover{
    a {
      font-weight: bold;
      color: #0094D4;
    }
  }
  ${(props) =>
    props.isActive &&
    css`
      .point {
        height: 115%;
        border-radius: 4px;
      }
    `}
`
//editor mode active
interface EditorSectionLinkImplProps extends PropsWithChildren<FC> {
    to: string
    title: string
}

/**TODO rewrite? */
const editorScrollToTitle = (to) => {
    const elements: Element[] = Array.from(document.getElementsByTagName("h2"))
    elements.forEach((el: Element) => {
        if(el.innerHTML == to) {
            el.scrollIntoView(
                {
                    behavior: 'smooth',
                    block:'center'
                }
            )
        }
    })
}

export const EditorSectionLinkImpl = forwardRef<HTMLDivElement, EditorSectionLinkImplProps>(
  (forwardedProps,ref)  => {
        return (
            <div className={'fr-view'}>
                <EditorSectionLinkGeneral ref={ref} className={'editor-span-title'} onClick={() => editorScrollToTitle(forwardedProps.to)}>{parse(forwardedProps.title)}</EditorSectionLinkGeneral>
            </div>
        )
    }
)

export const EditorSectionLinkGeneral = styled.div`
      font-size: 16px;
      line-height: 24px;
      margin-top:10px;
      display: block;
      cursor: pointer;
      position: relative;
      &:hover{
        font-weight:bold;
        color:#0094D4;
      }
`

export const EditorSectionLink = styled(EditorSectionLinkImpl)`
    
`

EditorSectionLinkImpl.displayName = 'EditorSectionLinkImpl'

interface SideBarImplProps extends PropsWithChildren<FC> {
  className?: string
}

export const SideBarImpl: FC<SideBarImplProps> = (props: SideBarImplProps) => {
  return <div className={props.className}>{props.children}</div>
}

export const SideBarTitle = styled.h2`
  margin: 0;
  color: #333333;
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
`

export const TableData = styled.td<{ wrap?: boolean }>`
  text-align: left;
  height: 100%;
  padding: 8px;
  display: table-cell;
  font-size: 13px;
  text-overflow: ellipsis;
  border: 1px solid #e6e4e4;
  ${(props) =>
    props.wrap &&
    css`
      word-wrap: break-word !important;
      overflow-wrap: break-word !important;
      word-break: break-word !important;
      white-space: -o-pre-wrap !important;
      white-space: pre-wrap !important;
      white-space: -moz-pre-wrap !important;
    `}
  vertical-align: top;
`

export const TableRow = styled.tr`
  display: table-row;
  height: 100%;
  width: 100%;
  background: #ffffff;
  &:nth-of-type(odd) {
    background: #f8f8f8;
  }
`

export const Table = styled.table`
  height: 100%;
  display: contents;
  border-radius: 5px;
  font-weight: normal;
  border: none;
  white-space: nowrap;
  background-color: white;

  thead {
    color: #000000;
    background: #ffffff;
  }

  th {
    text-align: left;
    padding: 8px;
    border: 1px solid #e6e4e4;
    font-weight: 600;
  }
`

export const SideBar = styled(SideBarImpl)<{
  editorModeActive: boolean
  fixedSideBar: boolean
  isExternal: boolean
  fixedSideBarMaxBottom: boolean
}>`
  margin-bottom: 20px;
  width: 296px;
  border-radius: 4px;
  background-color: #f2f4f8;
  padding: 16px;
  box-sizing: border-box;
  vertical-align: top;
  margin-right: 24px;
  display: block;
  text-align: left;
  transition: visibility 0.1s linear, opacity 0.1s linear;
  visibility: visible;
  opacity: 1;
  position: fixed;
  overflow: auto;
  max-height: calc(100vh - 150px);
  @media (max-width: 425px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 24px;
  }
  @media screen and (max-width: 1200px) {
    display: block;
    position: relative;
    width: auto;
    margin: 0 0 30px;
    top: 0;
  }
  ${(props) =>
    props.editorModeActive &&
    css`
        position: sticky;
        top: 23px;
        margin-right: 24px;
        float: left;
        left: calc(10px + (100%/2 - 610px));
        @media (max-width: 1000px) {
          width: 100%;
          margin-right: 0;
          margin-bottom: 24px;
          left: 10px;
        }
        @media screen and (max-width: 1248px) {
            display: block;
            position: relative;
            width: auto;
            margin: 0 0 30px;
            top: 0;
            left: 10px;
          }
    `}
  ${(props) =>
          !props.editorModeActive && props.fixedSideBar &&
          css`
            position: ${props.isExternal ? 'fixed' : 'absolute'};
            top: ${sidebarOffsetTop + (props.isExternal ? helpHeaderHeight : 0)}px;
          `}
  ${(props) =>
          !props.editorModeActive && props.fixedSideBarMaxBottom &&
          css`
      opacity: 1;
      visibility: visible;
    `}
`

export const ArticleInfoBox = styled.div`
  width: 200px;
  border-radius: 4px;
  background-color: #f2f4f8;
  padding: 16px;
  box-sizing: border-box;
  vertical-align: top;
  margin-right: 0;
  margin-left: 24px;
  display: inline-block;
  text-align: left;
  -webkit-transition: visibility 0.1s linear, opacity 0.1s linear;
  transition: visibility 0.1s linear, opacity 0.1s linear;
  visibility: visible;
  opacity: 1;
  float: right;
  /*h2 {
    color: #333333;
    font-size: 20px;
    font-weight: bold;
    line-height: 40px;
  }*/
`

interface RelatedArticlesImplProps
  extends PropsWithChildren<{ children: Element }> {
  className?: string
}
export const RelatedArticlesImpl: FC = (props: RelatedArticlesImplProps) => {
  return <div className={props.className}>{props.children}</div>
}
export const RelatedArticlesContainer = styled(RelatedArticlesImpl)`
  border-top: 1px solid rgba(51, 51, 51, 0.08);
  padding-top: 24px;
  margin-top: 24px;
  h3 {
    line-height: 40px;
    margin-bottom: 16px;
    font-size: 18px;
  }
  ul {
    padding: 0;
    -webkit-column-count: 2; /* Chrome, Safari, Opera */
    -moz-column-count: 2; /* Firefox */
    column-count: 2;
    -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
    -moz-column-gap: 40px; /* Firefox */
    column-gap: 40px;
    margin-left: 10px;
    li {
      color: ${FICColors.textDefault};
      margin-bottom: 20px;
      margin-left: 10px;
      font-size: 16px;
      width: 100%;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      span {
        cursor: pointer;
        color: ${FICColors.defaultBlue};
        &:hover {
          text-decoration: underline;
          &::before {
            text-decoration: none;
          }
        }
      }
    }
  }
`

interface SectionImplProps extends PropsWithChildren<FC> {
  onClick?: () => void
  className?: string
  isdragging?: number
}

export const SectionImpl = forwardRef<HTMLDivElement, SectionImplProps>(
  (forwardedProps, ref) => {
    return (
      <div
        {...forwardedProps}
        ref={ref}
        className={forwardedProps.className}
        onClick={forwardedProps.onClick}
      >
        {forwardedProps.children}
      </div>
    )
  }
)
SectionImpl.displayName = 'SectionImpl'

export const Section = styled(SectionImpl)`
  background-color: ${({ isdragging }) => isdragging ? `#0294d3` : FICColors.white};
  box-shadow: ${({ isdragging }) =>
  isdragging
      ? `0px 10px 13px -7px ${FICColors.blue900}, 5px 5px 5px -2px ${FICColors.blue900}`
      : '0 1px 1px 0 rgba(0, 0, 0, 0.05)'};
  color: ${({ isdragging }) =>
  isdragging ? FICColors.white : FICColors.textLink};
  height: auto;
  border: 1px solid rgba(51, 51, 51, 0.08);
  flex: 0 0 255px;
  @media screen and (max-width: 560px) {
    flex: 0 0 96%;
  }
  margin: 25px 12.5px 0;
  padding: 16px;
  box-sizing: border-box;
  vertical-align: top;
  text-align: left;
  border-radius: 5px;
  cursor: pointer;
  transition: box-shadow 0.3s ease-in-out;
  &:hover {
    box-shadow: 0 9px 16px 0 rgba(0, 0, 0, 0.1);
  }
  p {
    color: rgba(51, 51, 51, 0.64);
    font-size: 16px;
    line-height: 24px;
    @media (max-width: 425px) {
      font-size: 14px;
      line-height: 21px;
    }
  }
`

export const SectionTitle = styled.h2`
  font-size: 17px;
  font-weight: bold;
  line-height: 32px;
  margin-bottom: 5px;
  margin-top: 8px;
  color: #29323d;
  @media (max-width: 425px) {
    font-size: 16px;
    line-height: 24px;
  }
`
export const SectionDescription = styled.p`
  margin: 0;
`
export const SectionLoading = (
  <ContentLoader
    speed={2}
    viewBox='0 0 256 170'
    //primaryColor='#f3f3f3'
    //secondaryColor='#ecebeb'
  >
    <rect x='16.03' y='101' rx='3' ry='3' width='210' height='6.4' />
    <rect x='16.03' y='122' rx='3' ry='3' width='228' height='6.4' />
    <rect x='16.03' y='142' rx='3' ry='3' width='120.6' height='6.4' />
    <circle cx='42' cy='34' r='30' />
    <rect x='16.14' y='76.61' rx='0' ry='0' width='158.87' height='13.02' />
  </ContentLoader>
)

export const SectionEditableLoading = (
  <ContentLoader speed={2} viewBox='0 0 815 130'>
    <rect x='16.03' y='101' rx='3' ry='3' width='210' height='6.4' />
    <rect x='16.03' y='122' rx='3' ry='3' width='228' height='6.4' />
    <rect x='16.03' y='142' rx='3' ry='3' width='120.6' height='6.4' />
    <circle cx='42' cy='34' r='30' />
    <rect x='16.14' y='76.61' rx='0' ry='0' width='158.87' height='13.02' />
  </ContentLoader>
)

export const SectionIconImpl: FC<{
  className?: string
  icon: IconProp
}> = ({ className, icon }: { className?: string; icon: IconProp }) => (
  <div className={className}>
    <span className='iconContainer'>
      <>{icon && <Icon icon={icon} />}</>
    </span>
  </div>
)

export const SectionIcon = styled(SectionIconImpl)`
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background-color: #d6e9f7;
  text-align: center;
  display: inline-table;
  .iconContainer {
    margin-top: 7px;
    color: #319be6;
    display: table-cell;
    vertical-align: middle;
  }
  .svg-inline--fa {
    font-size: 23px;
  }
`

export const MainSectionDroppable = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

interface SectionsContainerImplProps extends PropsWithChildren<FC> {
  className: string
  isExternal?: boolean
}

export const SectionsContainerImpl: FC<SectionsContainerImplProps> = (
  props: SectionsContainerImplProps
) => <div className={props.className}>{props.children}</div>
export const SectionContainer = styled(SectionsContainerImpl)`
  max-width: 940px;
  margin: 0 auto;
  padding: 24px 16px;
  border-bottom: 1px solid rgba(51, 51, 51, 0.08);
  &:last-child {
    border: none;
  }
`

interface SectionListImplProps extends PropsWithChildren<FC> {
  className?: string
}

export const SectionListImpl: FC<SectionListImplProps> = (
  props: SectionListImplProps
) => <div className={props.className + ' sectionList'}>{props.children}</div>
export const SectionList = styled(SectionListImpl)`
  .sectionList {
    //margin-left: 35px;
  }
  h2 {
    font-size: 30px;
    color: #29323d;
    font-weight: bold;
    @media (max-width: 425px) {
      font-size: 22px;
    }
  }
  h3 {
    font-size: 25px;
    font-weight: bold;
  }
  h4 {
    font-size: 20px;
    font-weight: bold;
  }
  ul {
    margin: 20px 0 0 10px;
    li {
      color: ${FICColors.textDefault};
      margin-bottom: 20px;
      margin-left: 10px;
      font-size: 16px;
      line-height: 24px;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        cursor: pointer;
        color: ${FICColors.textLink};
        &:hover {
          text-decoration: underline;
          &::before {
            text-decoration: none;
          }
        }
      }
    }
  }
`

export const SectionLoadingSvg: FC<{ className?: string }> = (props: {
  className?: string
}) => {
  return (
    <div className={props.className + ' sectionListLoading'}>
      <BulletList className='bulletList' viewBox={'0 0 400 130'} />
    </div>
  )
}
export const SectionLoadingImpl = styled(SectionLoadingSvg)`
  width: 100%;
  height: 160px;
  margin: 35px auto;
  max-width: 940px;
  display: block;
  .bulletList {
    width: 400px;
  }
`

export const EditButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 12.5px;
  column-gap: 10px;
  align-items: baseline;
`
export const SaveOrder = styled(Button)`
  margin-top: 12px;
`
